var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5771",
    "data-name": "Group 5771",
    transform: "translate(-1075 -161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    transform: "translate(1075 193) rotate(-90)",
    fill: "#fff",
    stroke: "#0923e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M16.532,9.2,11.455,4.124a.423.423,0,0,0-.6.6l4.355,4.355H1.423a.423.423,0,1,0,0,.846H15.211l-4.355,4.355a.423.423,0,0,0,.6.6L16.533,9.8a.423.423,0,0,0,0-.6Z",
    transform: "translate(1081.5 186) rotate(-90)",
    fill: "#0923e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewUp);
export default __webpack_public_path__ + "static/media/preview_up.4df78d47eaba5b57aed9c0d933bae8d4.svg";
export { ForwardRef as ReactComponent };